import _ from 'lodash';

import { can } from 'services/can';
import { DealCategory } from 'common/constants/deals';
import { isInternalUser } from 'states/profile/business-rules';
import { PermissionsMapping } from 'common/constants/role-intents';

export default function selector(storeState) {
    const { loading, deals, keywords, sort, timezone, filters, advertisers } = _.get(
        storeState,
        'dealsTable'
    );

    let selectedDealsCategory = DealCategory.Private;
    if (location.pathname.split('/').pop() === 'curated-deals') {
        selectedDealsCategory = DealCategory.Curated;
    }
    if (location.pathname.split('/').pop() === 'guaranteed-deals') {
        selectedDealsCategory = DealCategory.Guaranteed;
    }
    const hasPermissionToEditCuratedDeals =
        isInternalUser() && can(PermissionsMapping.AUDITS__VIEW_AND_EDIT);

    const advertiserOptions = _.map(advertisers, advertiser => {
        return { label: advertiser.name, value: advertiser.id };
    });

    const filterDeals = deals.filter(deal => {
        return deal.category === selectedDealsCategory;
    });

    return {
        loading,
        deals: filterDeals,
        keywords,
        sort,
        timezone,
        filters,
        advertiserOptions,
        selectedDealsCategory,
        disableEditingDeal:
            selectedDealsCategory === DealCategory.Curated && !hasPermissionToEditCuratedDeals,
    };
}
